import React from "react";


const CheckMark = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 6L9 17L4 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Cross = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M6 6L18 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const BoxCountInfoModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#7876A1]/50 px-[24px] py-[18px] font-instrument">
      <div className="relative max-w-[328px] w-full bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Close button top-left */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute left-[13px] top-[14px] w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600"
        >
          <img
            src="/Vision Agent Icons/X Icon/XLightpurple.svg"
            alt="Close Icon"
          />
        </button>

        <div className="px-6 pt-[42.29px] pb-[18.7px] text-center">
          {/* Circular icon with info badge */}
          <div className="relative flex items-center justify-center">
            <img
              src="/images/NewUiIcons/ItemIcons2.svg"
              alt="box icon"
              className="w-[103px] h-[103px] object-contain"
            />

            <div className="absolute top-1 z-[1000] left-40 translate-x-3 bg-[#34318C] h-[31px] w-[31px] rounded-full flex items-center justify-center">
              <img
                src="/images/NewUiIcons/InfoIcon.svg"
                alt="info"
                className="w-[17px] h-[17px] object-contain filter invert brightness-0"
              />
            </div>
          </div>

          <h2 className="mt-6 text-[24px] font-semibold text-[#34318C] leading-[25px]">
            How to count
            <br /> boxes & bags?
          </h2>

          <ul className="mt-6 space-y-4 text-left">
            <li className="flex items-start gap-3 w-full">
              <div
                className="rounded-full flex items-center justify-center flex-shrink-0"
                style={{
                  width: "28.74px",
                  height: "28.74px",
                  background: "#C8C6DF",
                }}
              >
                <CheckMark className="w-3 h-3 text-[#34318C] font-semibold" />
              </div>
              <p className="flex-1 text-sm text-[#34318C] font-semibold break-words">
                Count packed cardboard boxes, plastic bins, suitcases, duffels.
              </p>
            </li>

            <li className="flex items-start gap-3 w-full">
              <div
                className="rounded-full flex items-center justify-center flex-shrink-0"
                style={{
                  width: "28.74px",
                  height: "28.74px",
                  background: "#C8C6DF",
                }}
              >
                <Cross className="w-3 h-3 text-[#34318C] font-semibold" />
              </div>
              <p className="flex-1 text-sm text-[#34318C] font-normal break-words">
                Don't include furniture, Moovez Vision™ already detected it
                from your photos.
              </p>
            </li>
          </ul>

          <button
            onClick={onClose}
            className="mt-[16px] w-full bg-[#34318C] text-white flex justify-center items-center py-3 h-[44px] rounded-[15px] font-semibold text-[16px] shadow-sm hover:bg-[#2d2a6b]"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoxCountInfoModal;
